<template>
  <div class="container" :style="messageColoring">
    <p class="message-prompt" v-html="promptText"></p>
  </div>
</template>

<script>
export default {
  name: "MessagePrompt",
  props: {
    promptText: {
      type: String,
      default: ""
    },
    isError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    messageColoring() {
      return {
        borderColor: this.isError ? 'red' : 'green',
        backgroundColor: this.isError ? '#f8ebea' : '#ebf8ea'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-grow: 1;
    align-items: center;
    border-left: 5px solid;
    padding: 10px;
  }
</style>
